// @flow
import * as React from "react";
import { withRouter } from "react-router";
import qs from "qs";
import type { AddMessage } from "../../components/FlashMessages/FlashMessageContext";

type AccountActionsFlashMessageProps = {
  children: React.Node,
  location: {
    state: { from?: ?string }
  },
  history: {
    push: any => void,
    location: { pathname: string, search: ?string }
  },
  addMessage: AddMessage
};

const ACCOUNT_ACTIVATION = "account_activation";
const ACCOUNT_UNLOCK = "account_unlock";

const messages = {
  [ACCOUNT_ACTIVATION]:
    "Ihr Account wurde erfolgreich aktiviert. Bitte melden Sie sich jetzt mit Ihren Daten an.",
  [ACCOUNT_UNLOCK]: "Freischaltung erfolgreich."
};

const useSuccessMessage = ({ addMessage, pathname, search, push, state }) => {
  React.useEffect(() => {
    if (!search) {
      return;
    }

    const { origin } = qs.parse(search.substring(1));

    if ([ACCOUNT_ACTIVATION, ACCOUNT_UNLOCK].includes(origin)) {
      addMessage(messages[origin], "success");
      push({
        pathname,
        state
      });
    }
  });
};

const AccountActionsFlashMessage = ({
  children,
  location: { state },
  history: {
    location: { pathname, search },
    push
  },
  addMessage
}: AccountActionsFlashMessageProps) => {
  useSuccessMessage({ addMessage, pathname, search, push, state });

  return children;
};

export default withRouter(AccountActionsFlashMessage);
